import {
  CHART_CONFIGURATION_FIELDS,
  USER_DATAPOINT_FIELDS_FOR_COT,
  USER_RESULT_FIELDS_TRUNCATED,
  USER_TEST_FIELDS_TRUNCATED
} from "@/graphql/tpo/results/types";
import { gql } from "@apollo/client";

export const GET_FIRST_USER_TEST = gql`
  query GetFirstUserTest($allTests: Boolean, $excludeRetests: Boolean, $excludeStatuses: [String]) {
    userTests(
      allTests: $allTests
      excludeRetests: $excludeRetests
      excludeStatuses: $excludeStatuses
    ) {
      id
    }
  }
`;

export const LAB_REPORTS_QUERY = gql`
  query LabReportsQuery($userTestId: ID!, $forPractitioner: Boolean) {
    userTest(userTestId: $userTestId) {
      id
      generatedPdf {
        id
        name
        userTest {
          id
        }
        pdfFile
      }
      dataFiles(forPractitioner: $forPractitioner) {
        id
        name
        dataFileUrl
        testDataFile {
          id
          fileType {
            id
            name
            contentType
            extension
          }
        }
      }
    }
  }
`;

export const GENES_TEST_BIOMARKERS_CONNECTION_QUERY = gql`
  query GENES_TEST_BIOMARKERS_CONNECTIONS_QUERY(
    $userResultId: ID
    $userTestId: ID
    $first: Int!
    $after: String
    $search: String
    $orderBy: String
    $includeModifiers: Boolean
    $testMode: Boolean
  ) {
    userDatapointConnections(
      userResultId: $userResultId
      userTestId: $userTestId
      after: $after
      first: $first
      search: $search
      orderBy: $orderBy
      includeModifiers: $includeModifiers
      testMode: $testMode
    ) {
      edges {
        cursor
        node {
          id
          value
          riskAllele
          datapoint {
            id
            name
            chartType
          }
        }
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
`;

export const USER_DATAPOINT_QUERY = gql`
  query USER_DATAPOINT_QUERY($userDatapointId: ID!) {
    userDatapoint(userDatapointId: $userDatapointId) {
      id
      uploaded
      dateExpired
      datapoint {
        id
        name
        category
        units
        description
        function
        reason
        chartType
        testProductSet {
          id
          paymentIsoCode
          organisation
          productFamily {
            id
            name
            slug
          }
        }
      }
      riskAllele
      value
      interpretation
      riskAllele
      chartConfiguration {
        ...ChartConfigurationFields
      }
      datapointState {
        id
        description
      }
    }
  }
  ${CHART_CONFIGURATION_FIELDS}
`;

export const RELATED_RESULTS_QUERY = gql`
  query RELATED_RESULTS_QUERY($userDatapointId: ID!) {
    userDatapoint(userDatapointId: $userDatapointId) {
      id
      uploaded
      results {
        ...UserResultFieldsTruncated
        isHidden
        resultState {
          id
          name
        }
        chartConfiguration {
          ...ChartConfigurationFields
        }
      }
    }
  }
  ${CHART_CONFIGURATION_FIELDS}
  ${USER_RESULT_FIELDS_TRUNCATED}
`;

export const RELATED_RESEARCH_QUERY = gql`
  query RelatedResearchQuery($userResultId: ID!) {
    userResult(userResultId: $userResultId) {
      id
      research {
        id
        name
        url
      }
    }
  }
`;

export const RESEARCH_RELATED_TO_USER_DATAPOINT_QUERY = gql`
  query RelatedResearchQuery($userDatapointId: ID!) {
    userDatapoint(userDatapointId: $userDatapointId) {
      id
      datapointState {
        id
        research {
          id
          name
          url
        }
      }
    }
  }
`;

export const USER_DATAPOINTS_QUERY = gql`
  query UserDatapointsQuery($datapointId: ID!, $cot: Boolean) {
    userDatapoints(datapointId: $datapointId, cot: $cot) {
      ...UserDatapointFieldsForCot
    }
  }
  ${USER_DATAPOINT_FIELDS_FOR_COT}
`;

export const USER_TESTS_AND_ORDERS_QUERY = gql`
  query UserTestsAndOrdersQuery($allTests: Boolean, $excludeRetests: Boolean) {
    userTests(allTests: $allTests, excludeRetests: $excludeRetests) {
      id
      name
      createdDateFormatted
      reviewStatus
      displayOrderId
    }
    ordersInProgress {
      id
      resultsReceivedByProvider
      sampleReceivedByProvider
      sampleReceivedByLab
      hasUserReport(mode: REPORT_AVAILABLE)
      nameInBasket
      registered
      testSentToUser
      product {
        id
        name
        paymentIsoCode
        organisation
        listingVisibility
      }
      userTestIds
      displayOrderId
    }
  }
`;

export const USER_TEST_QUERY = gql`
  query UserTestQuery($userTestId: ID!) {
    userTest(userTestId: $userTestId) {
      ...UserTestFieldsTruncated
      isGenesTest
      reviewStatus
      displayOrderId
    }
  }
  ${USER_TEST_FIELDS_TRUNCATED}
`;
